// eslint-disable-next-line no-shadow
export enum WindowFormat {
  wideDesktop = 'wideDesktop',
  desktop = 'desktop',
  tablet = 'tablet',
  mobile = 'mobile',
}
